import React from 'react'
import { connect } from 'react-redux';
import { goToPage, stepParams } from '../../DisconnectServiceSlice'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import './DisconnectInternetPage'
import { Container } from 'reactstrap';
import DisconnectContent from '../DisconnectCommonParts/DisconnectContent'
import gaParams from '../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../utilities/analytics/tracking';

function DisconnectInternetPage(props) {

    function redirectAndReportGA() {
        gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_DISCONNECT_PAGE.category, gaParams.DISCONNECT_CLICK_CONTINUE_DISCONNECT_PAGE.eventType, props.serviceToDisconnect.title);
        props.goToPage({ page: 'DISCONNECT_PRODUCTS_PAGE', params: { ...stepParams, hideHeader: false } })
    }

    return (
        <Container className="DisconnectInternetPage-root">
            <DisconnectContent />
            <div className="btn-proceed">
                <BtnSubmit text="המשך" onclick={() => redirectAndReportGA()}/>    
            </div>
        </Container>
    )
}


const mapStateToProps = (state) => ({
    stepInProcess: state.disconnectServicesBlock.stepInProcess,
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect
});
  
const mapDispatchToProps = {
    goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectInternetPage);